// Title screen — covers the scene on page load, dismissed by any key
// press or mouse click. While it's visible, main.js skips game update
// logic so the intro camera sweep starts the moment the player begins,
// not when the page loaded.
//
// Input stays blocked across the whole on-boarding: title → camera
// sweep → first dialog. The dialog is what unblocks, so the player
// can't start walking before they've read the opening log entry.

import { blockGameInput } from '../input.js';

let element   = null;
let started   = false;
let onStartCb = null;

// Touch-only devices can't play — the game is bound to WASD / space / etc.
// Swap the prompt copy so mobile visitors learn this before they tap.
function isTouchOnlyDevice() {
  return matchMedia('(hover: none) and (pointer: coarse)').matches;
}

export function initTitle(onStart) {
  element   = document.getElementById('title-screen');
  onStartCb = onStart || null;

  blockGameInput(true);

  if (isTouchOnlyDevice()) {
    const prompt = element?.querySelector('.title-prompt');
    if (prompt) {
      prompt.textContent = 'desktop browser with a keyboard required';
      prompt.classList.add('is-notice');
    }
    return;
  }

  const dismiss = () => {
    if (started) return;
    started = true;
    element?.classList.add('fading');
    document.getElementById('hint')?.classList.remove('hidden');
    // Deliberately leave input blocked — the opening dialog
    // (fired after the camera sweep) releases it when dismissed.
    onStartCb?.();
  };

  addEventListener('keydown',   dismiss);
  addEventListener('mousedown', dismiss);
}

export function hasStarted() {
  return started;
}
